import moment from "moment"

export function formatDateToWeek(date: string) {
  return moment.utc(date).format("GGGG-WW")
}
